define('fukit/behavior/base.unsaved.changes.behavior',['require','marionette','evicommon/state/changes.helper'],function(require) {
  //prettier-ignore
  var Mn            = require('marionette'),
      ChangesHelper = require('evicommon/state/changes.helper');

  var BaseUnsavedChangesBehavior = Mn.Behavior.extend({
    defaults: {
      // the model to listen for unsaved changes on
      model: null,
      // the collection to listen for unsaved changes on
      collection: null,
      // the changes helper to listen for unsaved changes on
      changesHelper: null,
      // should the enabling effect be inverted (i.e. disable on unsaved changes)
      invert: false,
      // if true, user is warned before navigating the browser away from the app if there are unsaved changes
      warnOnBeforeUnload: true,
    },

    onFirstRender: function() {
      Backbone.history.on('route', this.detachBeforeUnloadListener);
      this.setupUnsavedChangesModel();

      this.listenTo(this.view, 'change:model change:collection', function() {
        this.setupUnsavedChangesModel();
      });
    },

    setupUnsavedChangesModel: function() {
      // stop listening to existing unsaved changes model
      if (this.unsavedChangesModel) {
        this.stopListening(this.unsavedChangesModel);
      }

      this.unsavedChangesModel = this.getUnsavedChangesModel();

      if (!this.unsavedChangesModel) {
        return;
      }

      this.listenTo(this.unsavedChangesModel, 'change', function() {
        this.onUnsavedChanges();
      });

      this.onInitializeUnsavedChanges();
    },

    // override with custom implementation
    onInitializeUnsavedChanges: function() {},

    // override with custom implementation
    onUnsavedChanges: function() {},

    unsavedChangesExist: function() {
      if (this.unsavedChangesModel) {
        if (this.unsavedChangesModel.hasChanges() && this.getOption('warnOnBeforeUnload')) {
          window.onbeforeunload = this.handleUnsavedChangesBeforeUnload.bind(this);
        } else {
          window.onbeforeunload = null;
        }
        return this.unsavedChangesModel.hasChanges();
      }
      return false;
    },

    handleUnsavedChangesBeforeUnload: function(e) {
      var e = e ? e : window.event;
      if (!confirm('There are unsaved changes on the page. Are you sure you want to leave?')) {
        e.preventDefault();
        return false;
      }

      return true;
    },

    getUnsavedChangesModel: function() {
      var resource = this.getResource();

      if (this.getOption('changesHelper')) {
        return this.getOption('changesHelper');
      } else if (this.view.getOption('changesHelper')) {
        return this.view.getOption('changesHelper');
      } else if (resource instanceof Backbone.Model && resource.getUnsavedChangesModel) {
        if (resource.enableUnsavedChangesEvent) {
          resource.enableUnsavedChangesEvent();
        }
        return resource.getUnsavedChangesModel();
      } else if (resource instanceof Backbone.Model || resource instanceof Backbone.Collection) {
        var changesHelper = new ChangesHelper();
        changesHelper.add(resource);

        // save changes helper onto the model, so that it can be reused in the future
        resource.getUnsavedChangesModel = function() {
          return changesHelper;
        };

        return changesHelper;
      }
    },

    getResource: function() {
      return this.getOption('model') || this.getOption('collection') || this.view.model || this.view.collection;
    },
  });
  return BaseUnsavedChangesBehavior;
});

